import type { CallbackSubscription } from '@/engine/Utilities/CallbackManager';
import type { IFluoroAnglesIntegrationApi } from '../fluoroAngles/interfaces';
import { ViewPortManipulationApiBase } from './ViewPortManipulationApiBase';
import type * as THREE from 'three';

export class FluoroAnglesIntegrationApi extends ViewPortManipulationApiBase implements IFluoroAnglesIntegrationApi {
  // IFluoroAnglesIntegrationApi

  public trackCameraOrientationChanges(callback: (quaternion: THREE.Quaternion) => void): CallbackSubscription {
    return this._trackParentOrientation(callback);
  }
}
